import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from 'ngx-translate-with-country';
import { BreadcrumbsService } from 'ng6-breadcrumbs';
import { Title } from '@angular/platform-browser';
import { ContactService } from '../_services/contact.service';
import { PageService } from '../_services/page.service';
import { SimpleSmoothScrollService } from 'ng2-simple-smooth-scroll';
import { CategoryService } from '../_services/category.service';
import { LocationService } from '../_services/location.service';
declare var $: any;

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  country: string;
  language: string;
  id: number;
  page: any;
  countries: any;
  aboutBanner: any;
  timeChange: any;
  forLifeCommitment: any;
  ourTechnology: any;

  constructor(
    private locationService: LocationService,
    private _contactService: ContactService,
    public titleService: Title,
    private route: ActivatedRoute,
    public breadcrumbsService: BreadcrumbsService,
    private smooth: SimpleSmoothScrollService,

  ) { 
  }

  getCustomPages(country: string, language: string) {
    this._contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => {
          this.page = resJSONData[0];
          this.aboutBanner = resJSONData[0].aboutBanner.path;
          this.timeChange = resJSONData[0].timeChange.path;
          this.forLifeCommitment = resJSONData[0].forLifeCommitment.path;
          this.ourTechnology = resJSONData[0].ourTechnology.path;

        },
        error => console.log('Error ::' + error)
      );
  }

  getLocation(countryParam: string, languageParam: string): void {
    this.locationService.getLocation(countryParam, languageParam).subscribe(
      response => {
        this.countries = response;
      },
      error => console.log('Error ::' + error)
    );

  }

  
  ngOnInit() {
    console.log('gg');
    // setTimeout(() => {
    //   $(document).foundation();
    // }, 2000);

    this.smooth.smoothScrollToAnchor();
 
    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = +params['id'];
          this.country = this.locationService.country;
          this.language = this.locationService.langCode;
          this.getCustomPages(this.country, this.language);
          this.getLocation(this.country, this.language);
        }
      );
  }
}
